// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-authority-forms.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-authority-forms/flight-authority-carriage.js';
import g1 from '../lessons/air-law/flight-authority-forms/flight-authority-conditions.js';
import g2 from '../lessons/air-law/flight-authority-forms/flight-authority-forms.js';

mount([g0, g1, g2]);
